import React from 'react'
import {Button} from "antd";

const DetailPurchase = ({record}) => {

    return(
        <React.Fragment>
            <Button
                type={'link'}
            >
                <a target={'_blank'} rel="noopener noreferrer" href={`purchase/detail/${record.id}`}>Detay</a>
            </Button>
        </React.Fragment>
    )
}
export default DetailPurchase